// @LTG-ID: F-075
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 02_DESIGN_SYSTEM.md (signature design devices), 08_FEATURES.md#F-075
// @CHANGED: 2026-02 session_001
// @OWNER: web
//
// Bubble period — KGOB's signature terminal-punctuation device.
// Ported from /app/source_reference/Landing Page.html lines 118-134.
// CSS only. Color is themed via the `color` prop (defaults to --teal).
// Used heavily inside <h1> and <h2> headings on the landing page in P1+.

import "./bubble-period.css";

export const BubblePeriod = ({ color, style, className = "", ...rest }) => {
    const mergedStyle = color ? { ...style, "--bp-color": color } : style;
    return (
        <span
            aria-hidden="true"
            data-testid="bubble-period"
            className={`ltg-bubble-period ${className}`.trim()}
            style={mergedStyle}
            {...rest}
        />
    );
};

export default BubblePeriod;
